import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { X, Coffee } from "lucide-react";
import { Button } from "@/components/ui/button";

export const DonateBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const isAnalysisPage = location.pathname.startsWith('/analysis/');
    const isHomePage = location.pathname === '/';

    // Different logic for different pages
    if (isAnalysisPage) {
      // On analysis detail page: show more frequently (every 2 days)
      const dismissedUntilAnalysis = localStorage.getItem('donateBannerDismissedUntilAnalysis');

      if (!dismissedUntilAnalysis || Date.now() > parseInt(dismissedUntilAnalysis)) {
        // Show banner after a short delay
        setTimeout(() => setIsVisible(true), 3000);
      }
    } else if (isHomePage) {
      // On home page: show on first visit or after 7 days
      const hasVisited = localStorage.getItem('hasVisitedHome');
      const dismissedUntilHome = localStorage.getItem('donateBannerDismissedUntilHome');

      if (!hasVisited) {
        // First visit - show banner
        localStorage.setItem('hasVisitedHome', 'true');
        setTimeout(() => setIsVisible(true), 5000);
      } else if (!dismissedUntilHome || Date.now() > parseInt(dismissedUntilHome)) {
        // Returning visitor after dismissal period
        setTimeout(() => setIsVisible(true), 5000);
      }
    }
  }, [location.pathname]);

  const handleDismiss = () => {
    const isAnalysisPage = location.pathname.startsWith('/analysis/');

    if (isAnalysisPage) {
      // On analysis page: dismiss for 2 days
      const twoDaysFromNow = Date.now() + (2 * 24 * 60 * 60 * 1000);
      localStorage.setItem('donateBannerDismissedUntilAnalysis', twoDaysFromNow.toString());
    } else {
      // On home page: dismiss for 7 days
      const sevenDaysFromNow = Date.now() + (7 * 24 * 60 * 60 * 1000);
      localStorage.setItem('donateBannerDismissedUntilHome', sevenDaysFromNow.toString());
    }

    setIsDismissed(true);
  };

  if (!isVisible || isDismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-cyan-900/90 to-cyan-800/90 backdrop-blur-sm border-t border-cyan-500/30 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <Coffee className="w-5 h-5 text-cyan-400 flex-shrink-0" />
          <p className="text-sm font-mono text-gray-100 truncate">
            <span className="text-cyan-400 font-bold">NarrativeScout</span> is free and independent. 
            <span className="hidden sm:inline"> Support media literacy tools →</span>
          </p>
        </div>
        <div className="flex items-center gap-3 flex-shrink-0">
          <Button
            size="sm"
            onClick={() => window.open('https://ko-fi.com/narrativescout', '_blank')}
            className="bg-cyan-600 hover:bg-cyan-700 text-white font-mono whitespace-nowrap"
          >
            <Coffee className="w-4 h-4 mr-2" />
            DONATE
          </Button>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-100 transition-colors p-1"
            aria-label="Dismiss"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

